import { Switch } from './ui/switch';

/** A label + Switch row (the "generation default" toggle shape). */
export function SwitchRow({
  label,
  hint,
  checked,
  onCheckedChange,
}: {
  label: string;
  hint?: string;
  checked: boolean;
  onCheckedChange: (_v: boolean) => void;
}) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="text-[13px] text-[var(--tx-hi)]">{label}</div>
        {hint && <div className="mt-[2px] text-[11.5px] text-[var(--tx-faint)]">{hint}</div>}
      </div>
      <Switch checked={checked} onCheckedChange={onCheckedChange} className="mt-[2px]" />
    </div>
  );
}
